import React from "react";
import { Row, Col, Form } from "react-bootstrap";

interface PermissionsFiltersProps {
  value: string;
  onChange?: (value: string) => void;
}

const PermissionsFilters: React.FC<PermissionsFiltersProps> = ({
  value,
  onChange,
}) => {
  return (
    <Row className="g-2 justify-content-md-end align-items-end">
      <Col xs={12} className="min-w-0">
        <Form.Control
          type="text"
          placeholder="Search"
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
        />
      </Col>
    </Row>
  );
};

export default PermissionsFilters;
